import { render, staticRenderFns } from "./RepresentativeOrders.vue?vue&type=template&id=13ac158d&"
import script from "./RepresentativeOrders.vue?vue&type=script&lang=js&"
export * from "./RepresentativeOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports